var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb300",
    d: "M29.62 12.85L64 9.24l34.38 3.61L125 48.29l-61 70.47L3 48.29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea6c00",
    d: "M27.71 48.29L64 118.76 3 48.29h24.71zM100.29 48.29L64 118.76l61-70.47h-24.71z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdad00",
    d: "M27.71 48.29h72.58L64 118.76 27.71 48.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd231",
    d: "M64 9.24l-34.38 3.61-1.91 35.44L64 9.24zM64 9.24l34.38 3.61 1.91 35.44L64 9.24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdad00",
    d: "M125 48.29L98.38 12.85l1.91 35.44H125z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#feeeb7",
    d: "M64 9.24L27.71 48.29h72.58L64 9.24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdad00",
    d: "M3 48.29l26.62-35.44-1.91 35.44H3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.fce237dfe8854248613f0bdb7db459ee.svg";
export { ForwardRef as ReactComponent };